import { createStore } from '@stencil/store';

const { state, onChange } = createStore({
  lookupsDataMap: null,
});

function setLookupsDataMap(lookupsDataMap, replace = false) {
  if (replace) {
    state.lookupsDataMap = lookupsDataMap;
  } else {
    state.lookupsDataMap = { ...state.lookupsDataMap, ...lookupsDataMap };
  }
}

export { state, onChange, setLookupsDataMap };
